import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const FAQ = () => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(0);
  const faqs = [
    {
      question: t('support.faq.reservation.question'),
      answer: t('support.faq.reservation.answer')
    },
    {
      question: t('support.faq.cancellation.question'),
      answer: t('support.faq.cancellation.answer')
    },
    {
      question: t('support.faq.payment.question'),
      answer: t('support.faq.payment.answer')
    }
  ];

  return (
    <div className="space-y-4">
      {faqs.map((faq, index) => (
        <div key={faq.question} className="rounded-[24px] border border-stone-200 bg-stone-50/80 p-2">
          <button
            type="button"
            onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
            className="flex w-full items-center justify-between gap-4 rounded-[18px] px-4 py-4 text-left"
          >
            <span className="text-base font-semibold text-slate-900">{faq.question}</span>
            <span className="text-xl text-teal-700">{openIndex === index ? '-' : '+'}</span>
          </button>
          {openIndex === index ? <div className="px-4 pb-4 text-sm leading-7 text-slate-600">{faq.answer}</div> : null}
        </div>
      ))}
    </div>
  );
};

export default FAQ;
